<template>
  <v-chart
    :option="chartOptions"
    style="width: 600px; height: 400px;"
  ></v-chart>
</template>

<script>
import ECharts from "vue-echarts";
import "echarts";

export default {
  components: {
    "v-chart": ECharts
  },
  data() {
    return {
      chartOptions: {
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: ["Phase 1", "Phase 2", "Phase 3"]
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            name: "Transition",
            type: "line",
            stack: "total",
            data: [120, 132, 101]
          }
        ]
      }
    };
  }
};
</script>
